/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dry_Tiny_Cat_WaveInputs */

const fr_dry_tiny_cat_wave = /** @type {(inputs: Dry_Tiny_Cat_WaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurez les détails de l'exercice`)
};

/**

* @param {Dry_Tiny_Cat_WaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const dry_tiny_cat_wave = /** @type {((inputs?: Dry_Tiny_Cat_WaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dry_Tiny_Cat_WaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_dry_tiny_cat_wave(inputs)
});